import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Checkbox, Radio, Row, Col } from "antd";
import axios from "axios";
import { If, Then, Else, When } from "react-if";
import { comma } from "../Func.js";
import { CountUp } from "use-count-up";

function InvestModal({
  refreshPage,
  profitData,
  userInfo,
  creta,
  setLoading,
  setInvestModalOpen,
}) {
  const history = useHistory();
  const address = useSelector((state) => state.address.value);
  const tronweb = window.tronWeb;
  const [term, setTerm] = useState(false);
  const [term2, setTerm2] = useState(false);
  const [selectedPkg, setSelectedPkg] = useState(-1);
  const [miningTotalCreta, setMiningTotalCreta] = useState(0);
  const [currencyType, setCurrencyType] = useState("");
  const refResaleProfitWrap = useRef(null);

  const [pkgAmounts, setPkgAmounts] = useState({
    // pkg100: 0,
    pkg300: 0,
    pkg1000: 0,
    pkg3000: 0,
    pkg6000: 0,
    pkg10000: 0,
    pkg30000: 0,
    pkg60000: 0,
    pkg90000: 0,
    // pkg120000: 0,
  });

  const TRON_DEPOSIT_ADDRESS = process.env.REACT_APP_TRON_DEPOSIT_ADDRESS;
  const TRON_USDT_CONTRACT = process.env.REACT_APP_TRON_USDT_CONTRACT;

  useEffect(() => {}, []);

  const CountUpValue = (amount) => {
    if (amount === undefined || amount === 0 || amount === null) {
      return <CountUp end={0} thousandsSeparator="," />;
    } else {
      return (
        <CountUp isCounting start={0} end={amount} thousandsSeparator="," />
      );
    }
  };

  async function getUsdtBalance() {
    const { abi } = await tronweb.trx.getContract(TRON_USDT_CONTRACT);
    console.log(JSON.stringify(abi));

    const contract = await tronweb.contract(abi.entrys, TRON_USDT_CONTRACT);

    const balance = await contract.methods.balanceOf(address).call();
    console.log("balance:", balance.toString());

    return balance ? Number(balance / 1e6).toFixed(0) : 0;
  }

  async function invest() {
    let userDeposit = 0;
    if (profitData && profitData.deposit) {
      userDeposit = +profitData.deposit;
    }

    if (!currencyType) {
      alert("Select a currency.");
      return;
    }
    if (selectedPkg <= 0) {
      alert("Please select a package.");
      return;
    }

    if (selectedPkg <= userDeposit) {
      alert("You have selected the wrong package.(code:1)");
      return;
    }

    if (!term || !term2) {
      alert("Please accept the terms and conditions.");
      return;
    }

    if (currencyType === "USDT") {
      investUsdt(selectedPkg, pkgAmounts["pkg" + selectedPkg]);
    } else if (currencyType === "CRETA") {
      investCreta(selectedPkg, userDeposit, pkgAmounts["pkg" + selectedPkg]);
    }
  }

  // ------------------------------------------------------------------------------------------
  async function investCreta(pkg, deposit, amount) {
    if (amount <= 0) {
      alert("The incorrect selection. Please select again.(code:creta2)");
      return;
    }

    console.log("CRETA: " + creta);

    let cretaBalance = creta;
    if (cretaBalance < amount) {
      alert(
        `Insufficient CRETA balance. (insufficient: ${
          amount - cretaBalance
        } CRETA)`
      );
      return;
    }

    console.debug(`>>>> package: ${pkg}, amount: ${amount}`);

    setLoading(true);
    let result = await depositByCreta(pkg, pkg - deposit, amount);
    console.log("result: ", result);

    setInvestModalOpen(false);

    if (result === "OK") {
      alert("Investment was successful!!");
      refreshPage();
    } else {
      refreshPage();
    }

    setLoading(false);
  }

  async function depositByCreta(pkg, added_deposit, creta_amount) {
    let result = await axios
      .post("api/depositByCreta", {
        address,
        pkg,
        added_deposit,
        creta_amount,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        alert(err.response.data.message);
        return null;
      });

    return result;
  }

  // ------------------------------------------------------------------------------------------
  async function investUsdt(pkg, amount) {
    if (amount <= 0) {
      alert("The incorrect selection. Please select again.(code:usdt2)");
      return;
    }

    let usdtBalance = await getUsdtBalance();
    if (usdtBalance < amount) {
      alert(
        `Insufficient USDT balance. (insufficient: ${
          amount - usdtBalance
        } USDT)`
      );
      return;
    }

    console.debug(`>>>> package: ${pkg}, amount: ${amount}`);
    transfer(amount);
  }

  async function transfer(amount) {
    setLoading(true);
    try {
      let contract = await tronweb.contract().at(TRON_USDT_CONTRACT);

      console.log(">>>> contract: " + TRON_USDT_CONTRACT);
      console.log(">>>> from    : " + address);
      console.log(">>>> to      : " + TRON_DEPOSIT_ADDRESS);

      await contract
        .transfer(
          TRON_DEPOSIT_ADDRESS, //address _to
          amount * 1e6
        )
        .send({
          feeLimit: 1e9, // Set fee limit
          callValue: 0,
          userFeePercentage: 30,
          originEnergyLimit: 1e7,
        })
        .then(async (txid) => {
          console.log(txid);
          await txCheckFromBackend(txid); // transaction confirm 확인
        });
    } catch (error) {
      setLoading(false);
      console.error("trigger smart contract error", error);
      alert("The incorrect selection. Please select again.(code:3)");
    }
  }

  async function getDepositTxStatus(txid) {
    let result = await axios
      .post("api/getDepositTxStatus", {
        txid: txid,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return null;
      });

    return result;
  }

  async function txCheckFromBackend(txid) {
    for (let i = 0; i < 100; i++) {
      let result = await getDepositTxStatus(txid);
      if (result) {
        if (result.status === 1) {
          setLoading(false);
          alert("Transaction SUCCESS!");

          // history > dashboard 로 해야 invest 창이 닫김
          history.push("/history");
          history.push("/dashboard");
          return;
        } else if (result.status === 2) {
          setLoading(false);
          alert("Transaction fail error.");

          // history > dashboard 로 해야 invest 창이 닫김
          history.push("/history");
          history.push("/dashboard");
          return;
        } else {
          // ...
        }
      }

      await sleep(3000);
    }

    history.push("/history");
    history.push("/dashboard");
  }

  // ------------------------------------------------------------------------------------------

  function sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  const getInvestReturnRate = useCallback(() => {
    const pkg = +selectedPkg;
    console.log(
      userInfo.new_invest_return_rate_list
        .filter((x) => {
          const value = +x.min_value;

          if (value <= pkg) {
            return true;
          }
          return false;
        })
        .map((x) => {
          return +x.rate;
        })
    );
    const rate = Math.max(
      ...userInfo.new_invest_return_rate_list
        .filter((x) => {
          const value = +x.min_value;

          if (value <= pkg) {
            return true;
          }
          return false;
        })
        .map((x) => {
          return +x.rate;
        })
    );
    console.log("rate:", rate, rate * 100);
    return rate;
  }, [selectedPkg]);

  const updateMiningTotalCrate = useCallback(() => {
    // -------------------------------------------
    let cretaAmount = 0;
    if (currencyType == "USDT") {
      cretaAmount = Math.ceil(
        pkgAmounts["pkg" + selectedPkg] / userInfo.creta_system_price
      );
    } else if (currencyType == "CRETA") {
      cretaAmount = pkgAmounts["pkg" + selectedPkg];
    }

    const rate = getInvestReturnRate(); //+userInfo.new_invest_return_rate;
    const miningTotalCreta = Math.floor(cretaAmount * (1 + rate));
    console.log(
      "currencyType: ",
      currencyType,
      "selectedPkg: ",
      selectedPkg,
      "cretaAmount: ",
      cretaAmount,
      "miningTotalCreta:",
      miningTotalCreta
    );
    setMiningTotalCreta(miningTotalCreta);
    // -------------------------------------------
  }, [currencyType, selectedPkg]);

  const selectPkg = useCallback((pkg) => {
    console.log("pkg: ", pkg);
    if (profitData.deposit >= pkg) {
      return;
    }

    setSelectedPkg(pkg);
  }, []);

  useEffect(() => {
    updateMiningTotalCrate();
  }, [updateMiningTotalCrate]);

  // const scrollTop = () => refResaleProfitWrap.current.scrollIntoView({ block: 'start',  behavior: 'smooth' })

  const onChangeTerm = useCallback((e) => {
    setTerm(e.target.checked);
  }, []);

  const onChangeTerm2 = useCallback((e) => {
    setTerm2(e.target.checked);
  }, []);

  const onChangeCurrencyType = useCallback(
    (e) => {
      setCurrencyType(e.target.value);
      let type = e.target.value;
      let deposit = profitData.deposit;

      if (type === "USDT") {
        setPkgAmounts({
          // pkg100: 100 - deposit,
          pkg300: 300 - deposit,
          pkg1000: 1000 - deposit,
          pkg3000: 3000 - deposit,
          pkg6000: 6000 - deposit,
          pkg10000: 10000 - deposit,
          pkg30000: 30000 - deposit,
          pkg60000: 60000 - deposit,
          pkg90000: 90000 - deposit,
          // pkg120000: 120000 - deposit,
        });
      } else if (type === "CRETA") {
        const cretaPrice = +userInfo.creta_system_price;

        setPkgAmounts({
          // pkg100: Math.ceil((100 - deposit) / cretaPrice),
          pkg300: Math.ceil((300 - deposit) / cretaPrice),
          pkg1000: Math.ceil((1000 - deposit) / cretaPrice),
          pkg3000: Math.ceil((3000 - deposit) / cretaPrice),
          pkg6000: Math.ceil((6000 - deposit) / cretaPrice),
          pkg10000: Math.ceil((10000 - deposit) / cretaPrice),
          pkg30000: Math.ceil((30000 - deposit) / cretaPrice),
          pkg60000: Math.ceil((60000 - deposit) / cretaPrice),
          pkg90000: Math.ceil((90000 - deposit) / cretaPrice),
          // pkg120000: Math.ceil((120000 - deposit) / cretaPrice),
        });
      } else {
        setPkgAmounts({
          // pkg100: 0,
          pkg300: 0,
          pkg1000: 0,
          pkg3000: 0,
          pkg6000: 0,
          pkg10000: 0,
          pkg30000: 0,
          pkg60000: 0,
          pkg90000: 0,
          // pkg120000: 0,
        });
      }
    },
    [setCurrencyType, setPkgAmounts, userInfo, profitData]
  );

  const Package = (pkg) => {
    return (
      <div
        className={`button1 ${profitData.deposit >= pkg ? "disabled" : ""} ${
          selectedPkg === pkg ? "selected" : ""
        }`}
        onClick={() => selectPkg(pkg)}
      >
        <div className="pkg">PKG {comma(pkg)}</div>

        <If condition={currencyType !== ""}>
          <Then>
            <div className="amount">
              <If condition={pkgAmounts["pkg" + pkg] > 0}>
                <Then>
                  {comma(pkgAmounts["pkg" + pkg])}
                  &nbsp;{currencyType}
                </Then>
                <Else>- disabled -</Else>
              </If>
            </div>
          </Then>
        </If>
      </div>
    );
  };

  return (
    <div className="resale-profit-wrap" ref={refResaleProfitWrap}>
      <p className="mining-package">Mining Package</p>

      <If condition={profitData.deposit}>
        <Then>
          ( Your package is PKG{" "}
          {profitData.deposit ? comma(profitData.deposit) : 0} )
        </Then>
      </If>

      <hr />
      <h3>1. Select a currency.</h3>

      <Radio.Group onChange={(e) => onChangeCurrencyType(e)}>
        <Row>
          <Col span={12} align="left">
            <Radio value={"USDT"}>USDT</Radio>
          </Col>
          <Col span={12} align="left">
            <Radio value={"CRETA"}>CRETA</Radio>
          </Col>
        </Row>
      </Radio.Group>

      <hr />
      <h3>2. Select a package.</h3>
      <If condition={currencyType === "CRETA"}>
        <Then>
          <div className="profit-header">
            <p className="profit-name">Balance of CRETA</p>
            <span className="profit-data profit-data-flxd">
              {" "}
              {CountUpValue(creta)}{" "}
            </span>
          </div>

          <div className="color-gold text-center">
            CRETA price is ${userInfo ? comma(userInfo.creta_system_price) : ""}
          </div>
        </Then>
      </If>

      <div className="resale-profit-cont">
        {/* {Package(100)} */}
        {Package(300)}
        {Package(1000)}
        {Package(3000)}
        {Package(6000)}
        {Package(10000)}
        {Package(30000)}
        {Package(60000)}
        {Package(90000)}
        {/* {Package(120000)} */}
      </div>

      <If condition={currencyType && selectedPkg > 0}>
        <Then>
          <div className="mt-3 alert-box color-black text-center">
            Bonus Rate : {+Number(getInvestReturnRate() * 100).toFixed(2)}%
            <br />
            <span>
              <When condition={currencyType == "USDT"}>About </When>
              <span>
                <u>
                  <b>{comma(miningTotalCreta)} CRETA</b>
                </u>
              </span>
            </span>{" "}
            will be mined for one year
          </div>
        </Then>
      </If>

      <div className="checkT">
        <div className="caution2">
          3. I understood the marketing policy and the mining rules of CRETA
          tokens, and recognized that fluctuations in coin prices could lead to
          losses. I confirm that I am investing under my judgment and
          responsibility.
        </div>
        <div className="caution mb-3">
          <Checkbox
            className="user-term"
            checked={term}
            onChange={onChangeTerm}
          >
            {" "}
            Agree
          </Checkbox>
        </div>
        <div className="caution2">
          4. If any Commission or CRETA token is received after the investment
          is made, the investment will not be refunded. I understand and agree
          to the fact that there will be no refund.
        </div>
        <div className="caution mb-3">
          <Checkbox
            className="user-term"
            checked={term2}
            onChange={onChangeTerm2}
          >
            {" "}
            Agree
          </Checkbox>
        </div>
      </div>
      <div className="mb-3">
        <button className="btn btn-primary btn-lg w-100" onClick={invest}>
          Invest
        </button>
      </div>
    </div>
  );
}

export default InvestModal;
